import { render } from "./election-module.vue?vue&type=template&id=2603b548&scoped=true"
import script from "./election-module.vue?vue&type=script&lang=js"
export * from "./election-module.vue?vue&type=script&lang=js"

import "./election-module.vue?vue&type=style&index=0&id=2603b548&scoped=true&lang=css"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2603b548"]])

export default __exports__